import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { InstallationDetailsStore, InstallationFeaturesStore, InstallationsStore } from '@store';

import { InstallationService } from '../../+installations/services/installation.service';
import { RoutingService } from './routing.service';

@Injectable({
  providedIn: 'root',
})
export class InstallationDetailsGuard {
  // check for the string only contains number, text and '-'
  readonly VALID_FORMAT = /^[A-Za-z0-9-]+$/;

  constructor(
    private installationService: InstallationService,
    private installationDetailsStore: InstallationDetailsStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private installationsStore: InstallationsStore,
    private router: Router,
    private routingService: RoutingService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const installationId = route.params.id;
    const installationGatewaySerial = route.queryParamMap.get('gatewaySerial');

    const validInstallationId = this.VALID_FORMAT.test(installationId);
    const validInstallationGatewaySerial = this.VALID_FORMAT.test(installationGatewaySerial);

    if (!validInstallationId || !validInstallationGatewaySerial) {
      this.router.navigate(['/not-found']);

      return of(false);
    }

    return this.routingService.installationIdWithModifiedHistory$.pipe(
      switchMap((savedInstallationId) => {
        if (savedInstallationId !== installationId) {
          this.fetchData(installationId);
        }

        return of(true);
      })
    );
  }

  // Resolver responsibility
  // Fetch data only once - data is reusable in further guards
  // Following actions can cancel navigation when installation is invalid (404)
  private fetchData(installationId: number): void {
    this.installationsStore.resetDeregisterState();
    this.installationFeaturesStore.removeAllFeatures();
    this.installationService.setInstallationId(installationId);
    this.installationDetailsStore.readInstallationDetails(installationId);
  }
}
